import './about.style.scss';

const About = () => {
    return (
        <div id='about' className='about-container'>
            <h1>WHITE Consultant for Real Estate</h1>
            <p>WHITE Consultant for Real Estate is an independent real estate management company, committed to providing outstanding service and value to buyers, sellers, property owners, and tenants.</p>
            <p>WHITE Real Estate Consultant was conceived as a full-service real estate firm providing property management, brokerage, and consulting services for residential and commercial real estate in United Arab Emirates.</p>
            <p>An organization in which there is a principal at the helm of every deal, every negotiation, and every transaction. We are known for developing quality working relationships with our clientele, relationships based on respect, integrity, and trust.</p>
        </div>
    )
}

export default About;